const ERROR_MESSAGE = 'Duplicated reports' as const;

class DuplicateReportError extends Error {
    constructor() {
        super(ERROR_MESSAGE);
    }
}

export default DuplicateReportError;
